import React, { useContext } from 'react';
import Fade from 'react-reveal/Fade';

import PortfolioContext from '../../context/context';
import Title from '../Title/Title';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { createMuiTheme,styled,withStyles,ThemeProvider } from '@material-ui/core/styles';

const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'white',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'white',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'white',
      },
      '&:hover fieldset': {
        borderColor: 'white',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'white',
      },
    },
  },
})(TextField);

const MyButton = styled(Button)({
  background: '#fff',
  border: 0,
  borderRadius: 3,
  boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
  color: '#52beda',
  height: 48,
  padding: '0 30px',
});

const theme = createMuiTheme({
  typography: {
    fontSize: 20,
  },
  text:{
    color:'white',
  }
  
});

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    fontSize:20,
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },

  submit: {
    margin: theme.spacing(1),
    fontSize:20,
    
  },
  margin: {
    margin:theme.spacing(1),
    fontSize: 20,
    
  },
}));

const Contact = () => {
  const { contact } = useContext(PortfolioContext);
  const classes = useStyles();


  return (
    <section className="contact-wrapper" id="contact">
      
      <Container  component="main" maxWidth="xs">
      
      <CssBaseline />
        <Title title="Contact" />
        <p className="contact-wrapper_text">
              {'Would you like to work with me? Awesome!'}
            </p>
        <br/>
        <Fade bottom duration={1000} delay={800} distance="30px">
        
        
        <form name="contact" method="post" data-netlify-honeypot="bot-field"  noValidate data-netlify="true"  >
        <ThemeProvider theme={theme}>
        <input type="hidden" name="contact" value="contact"/>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CssTextField
              variant="outlined"
              className={classes.margin}
              fullWidth
              label="name"
              name="name"
              id="name"
              >

              </CssTextField>
            </Grid>
            <Grid item xs={12}>
            <CssTextField
              variant="outlined"
              className={classes.margin}
              fullWidth
              label="Contact Number"
              name="Contact Number"
              id="Contact Number"
              >

              </CssTextField>
            </Grid>
            <Grid item xs={12}>
              <CssTextField
              className={classes.margin}
                variant="outlined"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
              />
            </Grid>
            <Grid item xs={12}>
              <CssTextField
              className={classes.margin}
                variant="outlined"
                required
                fullWidth
                name="message"
                label="Message"
                type="message"
                id="message"
                multiline
                rows={4}
                autoComplete="current-message"
              />
            </Grid>
          </Grid>
          <MyButton
          size="large"
          fontSize="large"
            type="submit"
            fullWidth
            variant="contained"
          
            className={classes.submit}
          >
            Send
          </MyButton>
          </ThemeProvider>  
        </form>

        

        </Fade>
      </Container>
    </section>
  );
};

export default Contact;
